<template>
  <div class="repair-detail-page">
    <div class="repair-detail-card">
      <div class="detail-header">
        <div class="detail-title-group">
          <span class="detail-parent">工单池</span>
          <span class="detail-arrow">/</span>
          <span class="detail-title">工单详情</span>
        </div>
        <el-button size="small" class="detail-back-btn" @click="goBack">返回</el-button>
      </div>

      <div class="detail-info-panel">
        <div v-for="item in detailFields" :key="item.label" class="detail-field">
          <span class="detail-label">{{ item.label }}：</span>
          <span class="detail-value">{{ item.value || '-' }}</span>
        </div>
      </div>
    </div>

    <div class="detail-tab-card">
      <el-tabs v-model="currentTab" class="detail-tabs" @tab-click="changeTab(currentTab)">
        <el-tab-pane :label="$t('repairDetail.orderPhotos')" name="repairDetailPhotos"></el-tab-pane>
        <el-tab-pane :label="$t('repairDetail.repairItems')" name="repairDetailResource"></el-tab-pane>
        <el-tab-pane :label="$t('repairDetail.orderFlow')" name="repairDetailUser"></el-tab-pane>
        <el-tab-pane :label="$t('repairDetail.orderEvents')" name="repairDetailEvent"></el-tab-pane>
      </el-tabs>

      <div class="detail-tab-content">
        <repair-detail-photos v-if="currentTab === 'repairDetailPhotos'" ref="repairDetailPhotos" :repair-id="repairDetailInfo.repairId"></repair-detail-photos>
        <repair-detail-resource v-if="currentTab === 'repairDetailResource'" ref="repairDetailResource" :repair-id="repairDetailInfo.repairId"></repair-detail-resource>
        <repair-detail-user v-if="currentTab === 'repairDetailUser'" ref="repairDetailUser" :repair-id="repairDetailInfo.repairId"></repair-detail-user>
        <repair-detail-event v-if="currentTab === 'repairDetailEvent'" ref="repairDetailEvent" :repair-id="repairDetailInfo.repairId"></repair-detail-event>
      </div>
    </div>

    <div class="detail-footer-actions">
      <el-button size="small" class="detail-cancel-btn" @click="goBack">取消</el-button>
      <el-button type="primary" size="small" class="detail-print-btn" @click="printRepairDetail">打印</el-button>
    </div>

    <view-image ref="viewImage"></view-image>
    <reply-repair-appraise ref="replyAppraise"></reply-repair-appraise>
  </div>
</template>

<script>
import { getRepairDetail } from '@/api/work/repairDetailApi'
import RepairDetailPhotos from '@/components/work/repairDetailPhotos'
import RepairDetailResource from '@/components/work/repairDetailResource'
import RepairDetailUser from '@/components/work/repairDetailUser'
import RepairDetailEvent from '@/components/work/repairDetailEvent'
import ViewImage from '@/components/work/viewImage'
import ReplyRepairAppraise from '@/components/work/ReplyRepairAppraise'

export default {
  name: 'RepairDetailList',
  components: {
    RepairDetailPhotos,
    RepairDetailResource,
    RepairDetailUser,
    RepairDetailEvent,
    ViewImage,
    ReplyRepairAppraise
  },
  data() {
    return {
      currentTab: 'repairDetailPhotos',
      repairDetailInfo: {
        repairId: '',
        communityName: '',
        repairType: '',
        repairTypeName: '',
        repairName: '',
        tel: '',
        roomId: '',
        roomName: '',
        repairObjName: '',
        appointmentTime: '',
        appointmentStartTime: '',
        appointmentEndTime: '',
        submitHours: '',
        timeout: '',
        finishTime: '',
        context: '',
        repairContext: '',
        repairContent: '',
        stateName: '',
        userId: '',
        userName: '',
        photos: [],
        visitType: '',
        visitContext: '',
        maintenanceType: '',
        repairMaterials: '',
        repairFee: '',
        appraiseScore: 0,
        doorSpeedScore: 0,
        repairmanServiceScore: 0,
        average: 0.0
      }
    }
  },
  computed: {
    detailFields() {
      return [
        { label: '所在小区', value: this.repairDetailInfo.communityName },
        { label: '联系方式', value: this.repairDetailInfo.tel },
        { label: '提单时长', value: this.repairDetailInfo.submitHours },
        { label: '维修内容', value: this.repairDetailInfo.repairContext || this.repairDetailInfo.repairContent },
        { label: '工单编码', value: this.repairDetailInfo.repairId },
        { label: '位置', value: this.repairDetailInfo.repairObjName },
        { label: '完成时间', value: this.repairDetailInfo.finishTime },
        { label: '回返满意度', value: this.visitSatisfactionText },
        { label: '报修类型', value: this.repairDetailInfo.repairTypeName },
        { label: '预约开始时间', value: this.repairDetailInfo.appointmentStartTime || this.repairDetailInfo.appointmentTime },
        { label: '状态', value: this.repairDetailInfo.stateName },
        { label: '回访内容', value: this.repairDetailInfo.visitContext },
        { label: '报修人', value: this.repairDetailInfo.repairName },
        { label: '预约结束时间', value: this.repairDetailInfo.appointmentEndTime },
        { label: '报修内容', value: this.repairDetailInfo.context }
      ]
    },
    visitSatisfactionText() {
      if (!this.repairDetailInfo.visitType) {
        return ''
      }
      return this.repairDetailInfo.visitType === '1001' ? '满意' : '不满意'
    }
  },
  created() {
    const repairId = this.$route.query.repairId
    this.repairDetailInfo.repairId = repairId
    this.loadRepairDetail()
  },
  methods: {
    async loadRepairDetail() {
      try {
        const data = await getRepairDetail(this.repairDetailInfo.repairId)
        Object.assign(this.repairDetailInfo, data || {})
        this.changeTab('repairDetailPhotos')
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    printRepairDetail() {
      window.open(`/#/pages/property/printRepairDetail?repairId=${this.repairDetailInfo.repairId}&repairType=${this.repairDetailInfo.repairType}`)
    },
    changeTab(tab) {
      this.currentTab = tab
      setTimeout(() => {
        if (this.$refs[`${tab}`]) {
          this.$refs[`${tab}`].loadData()
        }
      }, 300)
    }
  }
}
</script>

<style scoped>
.repair-detail-page { min-height: 100%; padding: 0 24px 24px; background: #EBF2FA; }
.repair-detail-card, .detail-tab-card, .detail-footer-actions { background: #FFFFFF; border-radius: 12px; }
.repair-detail-card { padding: 20px 24px 24px; }
.detail-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 28px; }
.detail-title-group { display: flex; align-items: center; gap: 12px; font-family: 'PingFang SC', sans-serif; font-size: 16px; line-height: 22px; }
.detail-parent { color: #8C9BB4; font-weight: 500; }
.detail-arrow { color: #8C9BB4; }
.detail-title { color: #1D2129; font-weight: 400; }
.detail-back-btn, .detail-cancel-btn { width: 78px; height: 38px; padding: 0; border: 1px solid #0E76FF; border-radius: 10px; color: #0E76FF; background: #fff; font-weight: 500; }
.detail-info-panel { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); row-gap: 22px; column-gap: 48px; min-height: 192px; padding: 22px 24px; background: #F3F7FB; border-radius: 8px; }
.detail-field { display: flex; align-items: flex-start; min-width: 0; font-size: 14px; line-height: 20px; font-family: 'PingFang SC', sans-serif; }
.detail-label { flex: 0 0 auto; color: #8C9BB4; font-weight: 400; white-space: nowrap; }
.detail-value { color: #1D2129; font-weight: 400; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.detail-tab-card { margin-top: 16px; padding: 18px 24px 24px; min-height: 318px; }
.detail-tabs >>> .el-tabs__header { margin: 0; }
.detail-tabs >>> .el-tabs__nav-wrap::after { height: 1px; background: #DCE6F5; }
.detail-tabs >>> .el-tabs__item { height: 40px; padding: 0 40px 0 0; color: #1D2129; font-size: 16px; font-weight: 400; }
.detail-tabs >>> .el-tabs__item.is-active { color: #0E76FF; }
.detail-tabs >>> .el-tabs__active-bar { height: 3px; border-radius: 3px; background: #0E76FF; }
.detail-tab-content { padding-top: 24px; }
.detail-footer-actions { display: flex; justify-content: flex-end; gap: 12px; margin-top: 16px; padding: 28px 24px; }
.detail-print-btn { width: 98px; height: 38px; padding: 0; border-radius: 10px; background: #0E76FF; border-color: #0E76FF; font-weight: 500; }
.detail-cancel-btn { width: 98px; }
@media (max-width: 1400px) { .detail-info-panel { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width: 900px) { .repair-detail-page { padding: 0 12px 16px; } .detail-info-panel { grid-template-columns: 1fr; } }
</style>
